import axios from 'axios';

const saveAllMembers = (group, toast) => {
    axios.post(`/api/staffs/${group.group_id}`, {
        staff: group.staff_members.staff,
        conferencistas: group.staff_members.conferencistas,
        asistentes: group.staff_members.asistentes
    }).then(() => {            
        toast.success("Guardado correctamente");
    }).catch(error => {
        console.error('Error saving members:', error);
        toast.error('Error al guardar los miembros');
    });
}

const saveStaffMembers = async (group, toast, camposObligatorios, validarMandatorio, eventoToken) => {
    if (group.staff_members.staff.every(member => 
        [
            member.nombres,        
            member.apellidos,        
            member.numero_de_documento,        
            member.correo_electronico,        
            member.telefono,        
            member.ciudad,        
            member.pais,        
            member.departamento,        
            member.categoria,
            member.empresa,
            member.profesion,
            member.especialidad,
            member.direccion,
            member.indicativo_de_telefono,
        ].every(field => field.trim() === '' || field.trim() === '-- Seleccione --')
    )) {
        toast.info('No hay cambios que guardar para Staff.');
        return;
    }

    if (!(await validateMembers(group.staff_members.staff, toast, camposObligatorios, validarMandatorio, eventoToken, group.group_id))) {
        
        return;
    }

    return axios.post(`/api/staff/save-staff/${group.group_id}`, {
        staff: group.staff_members.staff
        }).then(response => {
            
            group.staff_members.staff.forEach((member, index) => {
                if (response.data.processedIds[index]) {
                    member.staff_id = response.data.processedIds[index];                
                }
            });
            toast.success('Staff guardado correctamente :)');
            return true;
        }).catch(error => {
            console.error('Error al guardar:', error);
            toast.error('Error al guardar');
            return false;
        });
}

const saveConferencistas = async(group, toast, camposObligatorios, validarMandatorio, eventoToken) => {
    if (group.staff_members.conferencistas.every(member => 
        [
            member.nombres,        
            member.apellidos,        
            member.numero_de_documento,        
            member.correo_electronico,        
            member.telefono,        
            member.ciudad,        
            member.pais,        
            member.departamento,        
            member.categoria,
            member.empresa,
            member.profesion,
            member.especialidad,
            member.direccion,
            member.indicativo_de_telefono,
        ].every(field => field.trim() === '' || field.trim() === '-- Seleccione --')
    )) {
       toast.info('No hay cambios que guardar para Expositores.');
        return;
        // Promise.resolve(); // Salir temprano si todo está vacío
    }
    // Cambio aquí para validar 'conferencistas'
    if (!(await validateMembers(group.staff_members.conferencistas, toast, camposObligatorios, validarMandatorio, eventoToken, group.group_id))) {
        return;
        // Promise.reject('Validación fallida para Conferencistas');
    }
    

   return axios.post(`/api/staff/save-conferencistas/${group.group_id}`, {
        conferencistas: group.staff_members.conferencistas
    }).then(response => {
         group.staff_members.conferencistas.forEach((member, index) => {
            if (response.data.processedIds[index]) {
                member.staff_id = response.data.processedIds[index];
                // console.log(member.staff_id);
            }
        });
       toast.success('Expositores guardados correctamente');
       return true;
    }).catch(error => {
        console.error('Error al guardar:', error);
        toast.error('Error al guardar');
        return false;
    });
}

const saveAsistentes = async(group, toast, camposObligatorios, validarMandatorio, eventoToken) => {
    if (group.staff_members.asistentes.every(member => 
        [
            member.nombres,        
            member.apellidos,        
            member.numero_de_documento,        
            member.correo_electronico,        
            member.telefono,        
            member.ciudad,        
            member.pais,        
            member.departamento,        
            member.categoria,
            member.empresa,
            member.profesion,
            member.especialidad,
            member.direccion,
            member.indicativo_de_telefono,
        ].every(field => field.trim() === '' || field.trim() === '-- Seleccione --')
    )) {
        toast.info('No hay cambios que guardar para Asistentes.');
        return;
        // Promise.resolve(); // Salir temprano si todo está vacío
    }
    // Uso correcto de validar 'asistentes'
    if (!(await validateMembers(group.staff_members.asistentes, toast, camposObligatorios, validarMandatorio, eventoToken, group.group_id))) {
        return;
        // Promise.reject('Validación fallida para Asistentes');
    }

    return axios.post(`/api/staff/save-asistentes/${group.group_id}`, {
        asistentes: group.staff_members.asistentes
    }).then(response => {
        group.staff_members.asistentes.forEach((member, index) => {
           if (response.data.processedIds[index]) {
               member.staff_id = response.data.processedIds[index];
            
           }
        });
       toast.success('Asistentes guardados correctamente');
       return true;
    }).catch(error => {
        console.error('Error al guardar:', error);
        toast.error('Error al guardar');
        return false;
    });
}

const fieldNames = {
    nombres: "Nombres",
    apellidos: "Apellidos",
    numero_de_documento: "Documento",
    tipo_de_documento: "Tipo de documento",
    correo_electronico: "Correo electrónico",
    telefono: "Teléfono",
    ciudad: "Ciudad",
    pais: "País",
    departamento: "Departamento",
    categoria: "Categoría",
    empresa: "Empresa",
    profesion: "Profesión",
    especialidad: "Especialidad",
    direccion: "Dirección",
    indicativo_de_telefono: "Indicativo de Teléfono",
};

const validateEmail = (email)=> {
    // Versión simplificada y clara sin escapes innecesarios
const re = /^([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
}

const checkForDuplicates = (members, camposObligatorios) => {
    let foundDuplicates = {};
    console.log( members)
    camposObligatorios.filter(campo => campo.mandatorio).forEach(campo => {
        // let values = members.map(member => member[campo.label].trim()).filter(value => value !== '' && value !== '-- Seleccione --');
        let values = members.map(member => String(member[campo.label]).trim()).filter(value => value !== '' && value !== '-- Seleccione --');

        let uniqueValues = new Set(values);
        if (values.length !== uniqueValues.size) { // Hay duplicados
            foundDuplicates[campo.label] = [...values].filter((item, index) => values.indexOf(item) !== index)[0]; // Obtiene el valor duplicado
        }
    });
    return foundDuplicates;
};


const validateMembers = async (members, toast, camposObligatorios, validarMandatorio, eventoToken, tokenGrupo) => {

    let duplicates = checkForDuplicates(members, camposObligatorios);
    if (Object.keys(duplicates).length > 0) {
        for (let [field, value] of Object.entries(duplicates)) {
            toast.error(`El campo ${fieldNames[field]} con valor ${value} está duplicado en los usuarios a guardar.`);
        }
        return false;
    }


    let allValid = true;
    let missingFields = new Set();
    let mandatories = {};

    members.forEach(member => {
        const isEffectivelyEmpty = [
            member.nombres,
            member.apellidos,
            member.numero_de_documento,
            member.correo_electronico,
            member.telefono,
            member.ciudad,
            member.pais,
            member.departamento,
            member.categoria,
            member.empresa,
            member.profesion,
            member.especialidad,
            member.direccion,
            member.indicativo_de_telefono,
        ].every(field => field.trim() === '' || field.trim() === '-- Seleccione --');

        if (isEffectivelyEmpty) {
            return;
        }

        camposObligatorios.forEach(campo => {
            // const fieldValue = member[campo.label].trim();
            const fieldValue = member[campo.label] ? member[campo.label].toString().trim() : '';
            if ((campo.requerido || campo.mandatorio) && (fieldValue === '' || fieldValue === '-- Seleccione --')) {
                missingFields.add(campo.label);
                allValid = false;
            }

              // Additional validation for document number
              if (campo.label === 'numero_de_documento' && fieldValue && !/^[a-zA-Z0-9]+$/.test(fieldValue)) {
                toast.error(`El campo Documento debe contener solo letras y números sin espacios ni símbolos.`);
                allValid = null;
            }

            // Additional validation for email
            if (campo.label === 'correo_electronico' && fieldValue && !validateEmail(fieldValue)) {
                toast.error(`El correo electrónico '${fieldValue}' no es válido.`);
                allValid = null;
            }


            if (campo.mandatorio && fieldValue !== '' && fieldValue !== '-- Seleccione --') {
                if(member.staff_id != undefined) {
                    mandatories[campo.label] = {
                        'valor': fieldValue,
                        'staff_id': member.staff_id
                    };
                    
                } else {
                    
                    mandatories[campo.label] = {
                        'valor': fieldValue,
                        'staff_id': null
                    };
                }
            }
        });
    });

    if (allValid == false) {
        const fieldsList = Array.from(missingFields).map(field => fieldNames[field] || field).join('", "');
        toast.error(`Todos los usuarios deben tener el campo "${fieldsList}" para poder guardarse.`);
        return false;
    } else if (allValid == null){
        return false;
    
    }else if (validarMandatorio && Object.keys(mandatories).length > 0) {
        try {
            // console.log(members);
            // return false;
            const response = await axios.post(`/api/validar-mandatorios/${eventoToken}/${tokenGrupo}`, mandatories);
            if (!response.data.passed) {
                const errorMessages = Object.entries(response.data.errors).map(([field, msg]) =>
                    msg.replace(field, fieldNames[field] || field)
                ).join(', ');
                toast.warning(`Error al guardar: ${errorMessages} ya esta registrado en este evento`);
                
                return false;
            }
        } catch (error) {
            console.error('Error en la validación de mandatorios:', error);
            toast.error('Hubo un error al validar los datos.');
            return false;
        }
    }

    return true;
};


export {
    saveAllMembers,
    saveStaffMembers,
    saveConferencistas,
    saveAsistentes
}
